module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 34);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 1 */

/***/
function (module, exports) {
  module.exports = require("prop-types");
  /***/
},,
/* 2 */

/* 3 */

/***/
function (module, exports) {
  module.exports = require("classnames/bind");
  /***/
},,,,,,
/* 4 */

/* 5 */

/* 6 */

/* 7 */

/* 8 */

/* 9 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  exports.default = InlineGrid;

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _bind = __webpack_require__(3);

  var _bind2 = _interopRequireDefault(_bind);

  var _align = __webpack_require__(19);

  var _align2 = _interopRequireDefault(_align);

  var _general = __webpack_require__(20);

  var _general2 = _interopRequireDefault(_general);

  var _size = __webpack_require__(21);

  var _size2 = _interopRequireDefault(_size);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var cx = _bind2.default.bind(_extends({}, _align2.default, _general2.default, _size2.default));

  function InlineGrid(_ref) {
    var align = _ref.align,
        children = _ref.children,
        size = _ref.size;

    var wrappedChildren = _react.Children.map(children, function (child, index) {
      if (!child) {
        return null;
      }

      var lastChild = children.length - 1 === index;
      var className = cx(_defineProperty({}, size, !lastChild));
      return _react2.default.createElement('div', {
        key: index,
        className: className
      }, child);
    });

    var containerClasses = cx('container', [align]);
    return _react2.default.createElement('div', {
      className: _general2.default.wrap
    }, _react2.default.createElement('div', {
      className: containerClasses
    }, wrappedChildren));
  }

  InlineGrid.propTypes = {
    align: _propTypes2.default.oneOf(Object.keys(_align2.default)),
    children: _propTypes2.default.node.isRequired,
    size: _propTypes2.default.oneOf([].concat(_toConsumableArray(Object.keys(_size2.default)), ['none']))
  };
  InlineGrid.defaultProps = {
    align: 'middle',
    justify: 'start',
    size: 'm'
  };
  /***/
},,,,,
/* 10 */

/* 11 */

/* 12 */

/* 13 */

/* 14 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  }); // IE10-11 and Edge use an older version of the grid spec.
  // Only use display: grid if the browser supports the new specification
  // https://github.com/Modernizr/Modernizr/blob/6ee39b9c99adcc512dc370cb9aba1e7702563612/feature-detects/css/cssgrid.js
  // `grid-template-rows` is only in the new grid syntax

  var isGridSupported = function () {
    return typeof CSS !== 'undefined' && CSS.supports('grid-template-rows', 'none');
  }();

  var isNode = function () {
    return typeof process !== 'undefined' && process.release && process.release.name === 'node';
  }();

  var canUseGrid = exports.canUseGrid = isNode || isGridSupported;
  /***/
},,,,,
/* 15 */

/* 16 */

/* 17 */

/* 18 */

/* 19 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "top": "align__top___23GkX alignItems-flexStart",
    "middle": "align__middle___36vRU alignItems-center",
    "bottom": "align__bottom___lPiYq alignItems-flexEnd"
  };
  /***/
},
/* 20 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "wrap": "general__wrap___kYC0C display-inlineBlock",
    "container": "general__container___3gViq display-flex"
  };
  /***/
},
/* 21 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "xl": "size__xl___3dV9V marginRight-xl",
    "l": "size__l___20gHX marginRight-l",
    "m": "size__m___3OOcA marginRight-m",
    "s": "size__s___3e9ei marginRight-s",
    "xs": "size__xs___1JOKe marginRight-xs",
    "xxs": "size__xxs___1aKEI marginRight-xxs",
    "none": "size__none___XHI34 marginRight-0"
  };
  /***/
},,,,,,,,,,,,,
/* 22 */

/* 23 */

/* 24 */

/* 25 */

/* 26 */

/* 27 */

/* 28 */

/* 29 */

/* 30 */

/* 31 */

/* 32 */

/* 33 */

/* 34 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.InlineGrid = exports.GridItem = undefined;

  var _GridItem = __webpack_require__(45);

  Object.defineProperty(exports, 'GridItem', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_GridItem).default;
    }
  });

  var _InlineGrid = __webpack_require__(9);

  Object.defineProperty(exports, 'InlineGrid', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_InlineGrid).default;
    }
  });

  var _Grid = __webpack_require__(48);

  var _Grid2 = _interopRequireDefault(_Grid);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Grid2.default;
  /***/
},,,,,,,,,,,
/* 35 */

/* 36 */

/* 37 */

/* 38 */

/* 39 */

/* 40 */

/* 41 */

/* 42 */

/* 43 */

/* 44 */

/* 45 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  exports.default = GridItem;

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _bind = __webpack_require__(3);

  var _bind2 = _interopRequireDefault(_bind);

  var _utils = __webpack_require__(14);

  var _general = __webpack_require__(46);

  var _general2 = _interopRequireDefault(_general);

  var _columns = __webpack_require__(47);

  var _columns2 = _interopRequireDefault(_columns);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var gridItemAlignments = ['auto', 'normal', 'stretch', 'center', 'start', 'end', 'self-start', 'self-end', 'left', 'right'];

  function GridItem(_ref) {
    var _cx;

    var align = _ref.align,
        children = _ref.children,
        columnGap = _ref.columnGap,
        columns = _ref.columns,
        columnSpan = _ref.columnSpan,
        columnSpanS = _ref.columnSpanS,
        columnSpanM = _ref.columnSpanM,
        columnSpanL = _ref.columnSpanL,
        fullWidth = _ref.fullWidth,
        justify = _ref.justify;
    var percentage = fullWidth ? 100 : 100 / columns * columnSpan;
    var style = {
      alignSelf: align,
      flexBasis: 'calc(' + percentage + '% - ' + columnGap + 'px)',
      justifySelf: justify
    };

    var cx = _bind2.default.bind(_extends({}, _general2.default, _columns2.default));

    var gridItemClassName = cx(_general2.default.gridItem, 'gridColumn-' + columnSpan, (_cx = {}, _defineProperty(_cx, 'gridColumn-' + columns, fullWidth), _defineProperty(_cx, 'breakPointS-gridColumn-' + columnSpanS, columnSpanS), _defineProperty(_cx, 'breakPointM-gridColumn-' + columnSpanM, columnSpanM), _defineProperty(_cx, 'breakPointL-gridColumn-' + columnSpanL, columnSpanL), _cx));

    if (!_utils.canUseGrid) {
      style.margin = columnGap / 2;
    }

    return _react2.default.createElement('li', {
      className: gridItemClassName,
      style: style
    }, children);
  }

  GridItem.propTypes = {
    align: _propTypes2.default.oneOf(gridItemAlignments),
    children: _propTypes2.default.node.isRequired,
    columns: _propTypes2.default.number,
    columnGap: _propTypes2.default.number,
    columnSpan: _propTypes2.default.number,
    columnSpanS: _propTypes2.default.number,
    columnSpanM: _propTypes2.default.number,
    columnSpanL: _propTypes2.default.number,
    fullWidth: _propTypes2.default.bool,
    justify: _propTypes2.default.oneOf(gridItemAlignments)
  };
  GridItem.defaultProps = {
    align: 'auto',
    columns: 2,
    columnGap: 20,
    columnSpan: 1,
    columnSpanS: null,
    columnSpanM: null,
    columnSpanL: null,
    fullWidth: false,
    justify: 'auto'
  };
  /***/
},
/* 46 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "gridItem": "general__gridItem___33eeJ flex-none listStyle-none"
  };
  /***/
},
/* 47 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "gridColumn-1": "columns__gridColumn-1___3eAf2",
    "gridColumn-2": "columns__gridColumn-2___25DCh",
    "gridColumn-3": "columns__gridColumn-3___2CtN4",
    "gridColumn-4": "columns__gridColumn-4___2_eT2",
    "gridColumn-5": "columns__gridColumn-5___QQ1Wn",
    "gridColumn-6": "columns__gridColumn-6___3Oibq",
    "gridColumn-7": "columns__gridColumn-7___1k-KJ",
    "gridColumn-8": "columns__gridColumn-8___37Pun",
    "gridColumn-9": "columns__gridColumn-9___2KuK2",
    "gridColumn-10": "columns__gridColumn-10___3qVkp",
    "gridColumn-11": "columns__gridColumn-11___tKelr",
    "gridColumn-12": "columns__gridColumn-12___j57FH",
    "breakPointS-gridColumn-1": "columns__breakPointS-gridColumn-1___1w1pF",
    "breakPointS-gridColumn-2": "columns__breakPointS-gridColumn-2___1xTk0",
    "breakPointS-gridColumn-3": "columns__breakPointS-gridColumn-3___eHtCC",
    "breakPointS-gridColumn-4": "columns__breakPointS-gridColumn-4____4GM9",
    "breakPointS-gridColumn-5": "columns__breakPointS-gridColumn-5___2moag",
    "breakPointS-gridColumn-6": "columns__breakPointS-gridColumn-6___dv3vu",
    "breakPointS-gridColumn-7": "columns__breakPointS-gridColumn-7___3WCY4",
    "breakPointS-gridColumn-8": "columns__breakPointS-gridColumn-8___1MBHA",
    "breakPointS-gridColumn-9": "columns__breakPointS-gridColumn-9___ql2wF",
    "breakPointS-gridColumn-10": "columns__breakPointS-gridColumn-10___33eM5",
    "breakPointS-gridColumn-11": "columns__breakPointS-gridColumn-11___ckVgh",
    "breakPointS-gridColumn-12": "columns__breakPointS-gridColumn-12___ObcJa",
    "breakPointM-gridColumn-1": "columns__breakPointM-gridColumn-1___3TNuF",
    "breakPointM-gridColumn-2": "columns__breakPointM-gridColumn-2___39fQb",
    "breakPointM-gridColumn-3": "columns__breakPointM-gridColumn-3___2dtzT",
    "breakPointM-gridColumn-4": "columns__breakPointM-gridColumn-4___28ms0",
    "breakPointM-gridColumn-5": "columns__breakPointM-gridColumn-5___2olEU",
    "breakPointM-gridColumn-6": "columns__breakPointM-gridColumn-6___FqX9i",
    "breakPointM-gridColumn-7": "columns__breakPointM-gridColumn-7___2cdbg",
    "breakPointM-gridColumn-8": "columns__breakPointM-gridColumn-8___2KZ8B",
    "breakPointM-gridColumn-9": "columns__breakPointM-gridColumn-9___6aKee",
    "breakPointM-gridColumn-10": "columns__breakPointM-gridColumn-10___3KT4f",
    "breakPointM-gridColumn-11": "columns__breakPointM-gridColumn-11___2m5r_",
    "breakPointM-gridColumn-12": "columns__breakPointM-gridColumn-12___1LNRa",
    "breakPointL-gridColumn-1": "columns__breakPointL-gridColumn-1___3Uzam",
    "breakPointL-gridColumn-2": "columns__breakPointL-gridColumn-2___Q4smf",
    "breakPointL-gridColumn-3": "columns__breakPointL-gridColumn-3___3odbK",
    "breakPointL-gridColumn-4": "columns__breakPointL-gridColumn-4___2331w",
    "breakPointL-gridColumn-5": "columns__breakPointL-gridColumn-5___3o14_",
    "breakPointL-gridColumn-6": "columns__breakPointL-gridColumn-6___1h609",
    "breakPointL-gridColumn-7": "columns__breakPointL-gridColumn-7___1ZpNh",
    "breakPointL-gridColumn-8": "columns__breakPointL-gridColumn-8___S3WTh",
    "breakPointL-gridColumn-9": "columns__breakPointL-gridColumn-9___341s7",
    "breakPointL-gridColumn-10": "columns__breakPointL-gridColumn-10___2-Sen",
    "breakPointL-gridColumn-11": "columns__breakPointL-gridColumn-11___ubRHd",
    "breakPointL-gridColumn-12": "columns__breakPointL-gridColumn-12___KaCez"
  };
  /***/
},
/* 48 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Grid;

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _utils = __webpack_require__(14);

  var _general = __webpack_require__(49);

  var _general2 = _interopRequireDefault(_general);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var gridAlignements = ['center', 'start', 'end', 'flex-start', 'flex-end', 'left', 'right', 'baseline', 'space-between', 'space-around', 'space-evenly', 'stretch', 'inherit', 'initial', 'unset'];
  var sizes = {
    xxs: 5,
    xs: 10,
    s: 15,
    m: 20,
    l: 40,
    xl: 80
  };
  /**
   * Grid uses CSS grid with a fallback flexbox implementation for IE and Edge.
   * This avoid complications with the older version of the grid specification
   * supported by these browsers.
   */

  function Grid(_ref) {
    var alignContent = _ref.alignContent,
        children = _ref.children,
        columns = _ref.columns,
        justifyContent = _ref.justifyContent,
        size = _ref.size;

    var childrenWithProps = _react2.default.Children.map(children, function (child) {
      return child ? _react2.default.cloneElement(child, {
        columns: columns,
        columnGap: sizes[size]
      }) : null;
    });

    var style = {
      alignContent: alignContent,
      justifyContent: justifyContent,
      gridGap: sizes[size],
      gridTemplateColumns: 'repeat(' + columns + ', 1fr)'
    };

    if (_utils.canUseGrid) {
      style.display = 'grid';
    } else {
      style.margin = -sizes[size] / 2;
    }

    return _react2.default.createElement('ul', {
      className: _general2.default.grid,
      style: style
    }, childrenWithProps);
  }

  Grid.propTypes = {
    alignContent: _propTypes2.default.oneOf(gridAlignements),
    children: _propTypes2.default.node.isRequired,
    columns: _propTypes2.default.number,
    justifyContent: _propTypes2.default.oneOf(gridAlignements),
    size: _propTypes2.default.oneOf(Object.keys(sizes))
  };
  Grid.defaultProps = {
    alignContent: 'initial',
    columns: 2,
    justifyContent: 'initial',
    size: 'm'
  };
  /***/
},
/* 49 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "grid": "general__grid___tNY7l display-flex flexWrap-wrap justifyContent-between"
  };
  /***/
}]);